<template>
  <div class="sidebar-page">
    <section class="sidebar-layout">
      <section
        class="sidebar-layout"
        @mouseenter="test = false"
        @mouseleave="test = true"
      >
        <b-sidebar
          position="static"
          mobile="hide"
          type="is-dark"
          :reduce="test"
          fullheight=""
          class="has-text-white"
          open
        >
          <div class="p-1">
            <div
              class="to"
              style="margin-bottom: 20px"
              @click="goTo('https://kgames.fr')"
            >
              <img
                src="/kcorp.png"
                height="36"
                width="36"
                class="ml-5"
                alt="kcorp"
              />
              <p v-if="!test" class="has-text-white has-text-weight-bold">
                Kgames
              </p>
            </div>
            <b-menu class="is-custom-mobile">
              <div
                v-for="(game, idx) in games"
                :key="idx"
                class="to"
                style=""
                @click="goTo(`https://kgames.fr/game/${game._id}`)"
              >
                <img
                  height="36"
                  width="36"
                  :src="`https://kgames.fr${game.icon}`"
                  alt="game"
                  class="is-rounded"
                />
                <p v-if="!test" class="has-text-white">
                  {{ game.name }}
                </p>
              </div>
            </b-menu>
          </div>
          <div
            class="premium"
            style="cursor: pointer;"
            @click="goTo('https://kgames.fr/premium')"
          >
            <b-icon icon="star-circle" />
            <p
              v-if="!test"
              class="has-text-weight-bold"
              style="white-space: nowrap; overflow: hidden;"
            >
              KGames Premium
            </p>
          </div>
        </b-sidebar>
      </section>

      <div id="app">
        <router-view class="app" />
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import "buefy/dist/buefy.css";
const queryString = require("query-string");
export default {
  data: () => ({
    mobile: "reduce",
    reduce: true,
    test: true,
    games: []
  }),
  methods: {
    goTo(url) {
      window.location.replace(url);
    }
  },
  mounted: async function() {
    let roomId = queryString.parse(location.search).join;
    if (
      (this.$colyseus.room == undefined || this.$colyseus.room.id != roomId) &&
      location.pathname != "/"
    )
      this.$router.push("/");

    history.pushState(null, null, location.href);
    window.onpopstate = function() {
      history.go(1);
    };
    try {
      let games = (await axios.get("/api/games")).data;
      this.games = games;
    } catch (e) {
      console.error(e);
    }
  }
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/palette.scss";
@import url("https://fonts.googleapis.com/css2?family=Luckiest+Guy&display=swap");

$carousel-arrow-icon-spaced: -0rem;
$carousel-arrow-color: black;

h1 {
  font-family: "Luckiest Guy", cursive;
}

.premium {
  display: flex;
  color: white;
  align-items: center;
  justify-content: space-evenly;
  background-color: #d7b740;
  height: 50px;
}

.is-rounded {
  border-radius: 5px;
}

.to {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
}

.to:hover {
  background: lighten($color: #363636, $amount: 3);
}

.to * {
  flex-shrink: 0;
}

.to img {
  margin-right: 20px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  height: inherit;
  width: 100%;
}

.app {
  height: 100%;
  background-color: $intru-1-hex;
}
h1 {
  font-weight: bolder !important;
  font-size: 7vmin !important;
  color: $intru-5-hex !important;
}

h2 {
  font-weight: bold !important;
  font-size: 5vmin !important;
  color: white;
}

h3 {
  font-weight: bold !important;
}

.disconnected {
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
  text-decoration: line-through;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

body {
  height: 100%;
  min-height: 100vh;
  width: 100vw;
  background-color: $intru-1-hex;
}

label {
  color: white !important;
}
.p-1 {
  padding: 1em;
}
.sidebar-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  height: 100vh;
  // min-height: 100vh;
  .sidebar-layout {
    height: 100vh;
    display: flex;
    flex-direction: row;
    min-height: 100%;
    // min-height: 100vh;
  }
}
@media screen and (max-width: 1023px) {
  .b-sidebar {
    .sidebar-content {
      &.is-mini-mobile {
        &:not(.is-mini-expand),
        &.is-mini-expand:not(:hover) {
          .menu-list {
            li {
              a {
                span:nth-child(2) {
                  display: none;
                }
              }
              ul {
                padding-left: 0;
                li {
                  a {
                    display: inline-block;
                  }
                }
              }
            }
          }
          .menu-label:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .b-sidebar {
    .sidebar-content {
      &.is-mini {
        &:not(.is-mini-expand),
        &.is-mini-expand:not(:hover) {
          .menu-list {
            li {
              a {
                span:nth-child(2) {
                  display: none;
                }
              }
              ul {
                padding-left: 0;
                li {
                  a {
                    display: inline-block;
                  }
                }
              }
            }
          }
          .menu-label:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
